import { supabase } from '../config/supabase';

export const folderService = {
  // Create new folder
  async createFolder(projectId, name, folderType = 'door') {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('folders')
      .insert([{
        name,
        folder_type: folderType,
        project_id: projectId,
        created_by: user.id
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Delete folder
  async deleteFolder(folderId) {
    const { error } = await supabase
      .from('folders')
      .delete()
      .eq('id', folderId);

    if (error) throw error;
    return true;
  },

  // Get folders for project
  async getProjectFolders(projectId) {
    const { data, error } = await supabase
      .from('folders')
      .select(`
        *,
        files(*),
        door_metadata(*)
      `)
      .eq('project_id', projectId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  }
};

export default folderService;
